import Remarkable from 'remarkable';

export default function renderMarkdown(content) {
  const md = new Remarkable();
  const html = md.render(content);
  return html;
}



// WEBPACK FOOTER //
// ./src/core/markdown.js